import { style } from 'typestyle'
export const p8 = style({ padding: '8px' })
